import { FilterProp } from 'frontend/types'
import { activeOptionLabel } from 'frontend/utils/helpers'
import FilterDropdown from './FilterDropdown/FilterDropdown'
import { SearchParams } from 'backend/services/types/urApiService.types'
import { DefaultOptions, SortOptions } from 'frontend/enums'
import { filterSortClick } from 'frontend/utils/analytics/dataLayerDispatchers'

const BASE_OPTIONS: FilterProp[] = [
  {
    label: 'A-Ö',
    value: SortOptions.TITLE,
    available: true,
  },
  {
    label: 'Nytt på Play',
    value: SortOptions.PUBLISHED,
    available: true,
  },
  {
    label: 'Populärast',
    value: SortOptions.MOST_VIEWED,
    available: true,
  },
]

export const SORT_BY_RELEVANCE: FilterProp = {
  label: 'Bästa sökträff',
  value: DefaultOptions.EMPTY,
  available: true,
}

type Props = {
  searchParams: SearchParams
  updateSearch: (params: SearchParams) => void
  includeRelevance: boolean
  isOnMobile?: boolean
}

const Sort = ({
  searchParams,
  updateSearch,
  includeRelevance,
  isOnMobile,
}: Props) => {
  let { sort = includeRelevance ? DefaultOptions.EMPTY : SortOptions.TITLE } =
    searchParams

  if (sort === SortOptions.AVAILABILITY_ENDING) {
    sort = SortOptions.MOST_VIEWED
  }

  const options = includeRelevance
    ? [SORT_BY_RELEVANCE].concat(BASE_OPTIONS)
    : BASE_OPTIONS

  const activeLabels = activeOptionLabel(options, sort)

  const handleOptionSelect = (option: FilterProp) => {
    const isSelected = activeLabels.includes(option.label)

    if (!isSelected) filterSortClick(option.label)

    updateSearch({
      sort: option.value as SortOptions,
    })
  }

  return (
    <FilterDropdown
      activeLabels={activeLabels}
      label={activeLabels[0]}
      onOptionSelect={handleOptionSelect}
      options={options}
      isSingleChoice
      isOnMobile={isOnMobile}
      dataTestId={isOnMobile ? 'mobile-sort-button' : 'sort-button'}
    />
  )
}

export default Sort
